import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="container">
    <div className="row">
    <div className="col-sm-1" id='test'></div>
    <div className="col-sm-10" id='midrow'>
    <App />
    </div>
    </div>
    </div>
  </React.StrictMode>
);

reportWebVitals();
